import DataGrid, {
    Column,
    Pager,
    Paging,
    FilterRow,
    Lookup,
    Export,
    HeaderFilter
} from 'devextreme-react/data-grid';
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/auth';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import TabPanel, { Item } from "devextreme-react/tab-panel";
import axios from 'axios';
import { backendlink } from '../../config';
import { PartnerCustomerListDatagrid, PartnerDoctorListDatagrid, PartnerPatientLogDatagrid } from '../../components';
import HomeHealthIcon from "../../svg/Property 1=home_health_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24.svg";
import PersonIcon from "../../svg/Property 1=person_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24 1.svg";
import StethoscopeIcon from "../../svg/Property 1=stethoscope_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24.svg";

export default function PartnerPatientLogPage() {
    const { user } = useAuth();
    const navigate = useNavigate();

    const [tabSelectedIndex, setTabSelectedIndex] = useState(2)

    function onTitleClick(e) {
        var itemIndex = e.itemIndex;
        var isReselected = false;

        if (itemIndex == tabSelectedIndex) {
            isReselected = true
        }

        setTabSelectedIndex(itemIndex)

        if (itemIndex == 2 && isReselected == true) {
            navigate('/partner-customer?tabSelectedIndex=2');
        }
    }

    useEffect(() => {
        if (user.usertype == "CP" || user.usertype == "DIST") {

        } else {
            navigate('/');
        }
    }, []);

    return (
        <React.Fragment>
            <TabPanel className={'content-block dx-card responsive-paddings'} defaultSelectedIndex={2} swipeEnabled={false} scrollByContent={true} showNavButtons={true} onTitleClick={onTitleClick}>
                <Item title="Organization" icon={HomeHealthIcon}> 
                    <PartnerCustomerListDatagrid />
                </Item>

                <Item title="Doctor" icon={StethoscopeIcon}> 
                    <PartnerDoctorListDatagrid />
                </Item>
    
                <Item title="Patient" icon={PersonIcon}> 
                    <PartnerPatientLogDatagrid />
                </Item>
            </TabPanel>
        </React.Fragment>
    );
}